import React, { useEffect } from 'react';

import { colors, fontSize } from 'styles/cp';

interface ChatDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  content: React.ReactNode;
}

const ChatDrawer: React.FC<ChatDrawerProps> = ({ isOpen, onClose, content }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  // Styling for drawer
  const drawerStyles: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    right: isOpen ? 0 : '-100%',
    width: '384px',
    height: '100%',
    backgroundColor: 'white',
    boxShadow: '-4px 0px 8px rgba(0,0,0,0.2)',
    transition: 'right 0.3s ease-in-out',
    overflow: 'auto',
    zIndex: 1001,
  };

  // Styling for backdrop
  const backdropStyles: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    opacity: isOpen ? 1 : 0,
    visibility: isOpen ? 'visible' : 'hidden',
    transition: 'opacity 0.3s ease-in-out',
    zIndex: 1000,
  };

  // Styling for the close icon
  const closeIconStyles: React.CSSProperties = {
    position: 'absolute',
    top: '-2px',
    right: '20px',
    cursor: 'pointer',
    fontSize: fontSize.xxxl,
    color: colors.gray,
  };

  return (
    <>
      <div style={backdropStyles} onClick={onClose} data-testid="chat-drawer-backdrop" />
      <div style={drawerStyles} onClick={(e) => e.stopPropagation()} data-testid="chat-drawer">
        <div style={closeIconStyles} onClick={onClose} data-testid="chat-drawer-close">
          ×
        </div>
        {content}
      </div>
    </>
  );
};

export default ChatDrawer;
